module.exports = __webpack_public_path__ + "static/media/straightLineDark.dc69a8fb.svg";